import { RoomStatusProps } from "../../../../interfaces/RoomStatusProps.interface"
import RoomCardHeader from "../../shared/RoomCardHeader/RoomCardHeader"
import VerticalContainer from "../../shared/VerticalContainer/VerticalContainer"

import "./Occupied.css"
import Wrapper from "../../shared/Wrapper/Wrapper"
import { useTimePulse } from "src/shared/hooks/useTimePulse"
import { useDate } from "src/shared/hooks/useDate"
import { useElapsedTime } from "src/shared/hooks/useElapsedTime"
import Icon from "src/shared/icons"
import useMinuteTimer from "src/shared/hooks/useMinuteTimer"
import { formatTime } from "src/shared/utils/formatTime"
import getOccupiedStatus from "../../../../helpers/getOccuppiedStatus"
import { MainTimerValue, rsTimerValue } from "../../../../helpers/getOccuppiedStatus.type"
import getFirstConceptoPendiente from "../../../../helpers/getFirstConceptoPendiente"

const Occupied = ({
    roomNumber,
    roomTypeName,
    occupiedExtraHours = 0,
    roomServiceTimeEnd = "",
    occupiedTimeEnd = "",
    extraTime,
    hasIncidences,
    occupiedTimeEndCondensada = "",
    placas,
    lastRentStatus,
    easyrewards,
    ultimaOrden,
    fecha_antigua_por_entregar,
    dateStatusChanged,
    zonaHoraria,
    room,
}: RoomStatusProps) => {
    const [now] = useTimePulse()

    const { UTCStringToLocalDate, localDateToUTCString } = useDate()
    const { older } = getFirstConceptoPendiente(room?.ultima_renta?.ultimos_conceptos_pendientes)

    const status = getOccupiedStatus({
        now,
        occupiedTimeEndCondensada,
        ultimaOrden,
        ultimos_conceptos_pendientes: room?.ultima_renta?.ultimos_conceptos_pendientes,
        occupiedTimeEnd,
        roomNumber,
        olderConceptoPendiente: older,
        fecha_antigua_por_entregar,
    })

    const [occuppiedElapsedTime] = useElapsedTime(
        UTCStringToLocalDate(occupiedTimeEndCondensada),
        "noche",
        room?.ultima?.renta?.estado === "pendiente_pago"
    )

    // La renta puede estar expirada aunque exista un pago pendiente (mainTimer === payASC),
    // por lo que el color del timer de renta se decide por la fecha, no por el mainTimer.
    const isRentaExpirada = !!occupiedTimeEndCondensada && UTCStringToLocalDate(occupiedTimeEndCondensada) < now

    const { timeValue: paymentPendingRawTimer } = useMinuteTimer({
        timeStartUTC: older?.date ? localDateToUTCString(older.date) : "",
    })

    const { timeValue: orderTimer } = useMinuteTimer({
        timeStartUTC: fecha_antigua_por_entregar
            ? fecha_antigua_por_entregar
            : ultimaOrden?.orden?.fecha_registro || "",
    })

    return (
        <Wrapper
            alertBgColor1={status?.alert ? "var(--ocupada-card-1)" : null}
            alertBgColor2={status?.alert ? "var(--pink-ocupado-light)" : null}
            hasIncidences={hasIncidences}
            bgColor="var(--pink-ocupado-light)"
        >
            <RoomCardHeader
                iconName={status?.icon || "BedFilled"}
                orderTimer={(status?.rsTimer !== rsTimerValue.NA && orderTimer) || ""}
                paymentPendingTimer={
                    status?.mainTimer === MainTimerValue.payASC
                        ? formatTime({ time: paymentPendingRawTimer, withHours: true })
                        : ""
                }
                timeout={
                    status?.rsTimer !== rsTimerValue.NA
                        ? status?.rsTimer === rsTimerValue.ASCExcedido
                        : status?.mainTimer === MainTimerValue.payASC
                        ? !!status?.alert
                        : undefined
                }
                roomTypeName={roomTypeName}
                roomNumber={roomNumber}
                hasIncidences={hasIncidences}
                iconBgColor="var(--pink-ocupado)"
                roomTypeAbbreviation={roomTypeName[0]}
                iconBgSecondaryColor="var(--pink-ocupado)"
                easyrewards={easyrewards}
            />
            <VerticalContainer>
                {isRentaExpirada ? (
                    <span className="room-card--md--occupied__timer--timeout">+{occuppiedElapsedTime}</span>
                ) : (
                    <span className="room-card--md--occupied__timer">{occuppiedElapsedTime}</span>
                )}
                <div className="room-card--md--occupied__description">
                    <Icon name={placas ? "car" : "walking"} style={{ marginRight: "5px" }} />
                    {placas ? placas : "A pie"}
                </div>
            </VerticalContainer>
        </Wrapper>
    )
}

export default Occupied
